"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetSubtypeToJSON = exports.AssetSubtypeFromJSONTyped = exports.AssetSubtypeFromJSON = exports.AssetSubtype = void 0;
/**
 * Asset subtype only required for asset type AUDIO.
 * @export
 */
exports.AssetSubtype = {
    AdstudioSuppliedAudio: 'ADSTUDIO_SUPPLIED_AUDIO',
    BackgroundMusic: 'BACKGROUND_MUSIC',
    UserUploadedAudio: 'USER_UPLOADED_AUDIO'
};
function AssetSubtypeFromJSON(json) {
    return AssetSubtypeFromJSONTyped(json, false);
}
exports.AssetSubtypeFromJSON = AssetSubtypeFromJSON;
function AssetSubtypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AssetSubtypeFromJSONTyped = AssetSubtypeFromJSONTyped;
function AssetSubtypeToJSON(value) {
    return value;
}
exports.AssetSubtypeToJSON = AssetSubtypeToJSON;
